export type MatchaFeeType = 'auto' | 'standard' | 'crossChain' | 'limitOrder' | 'solana';

/** Fee types sent to 0x as Matcha's integrator fee. */
export type MatchaSwapFeeFlow = Extract<MatchaFeeType, 'standard' | 'auto'>;

export type MatchaFeeConfig = {
  /** Fee applied to default trades, in basis points. */
  default: number;
  /**
   * Fee applied to like-kind pairs, in basis points. Cross-chain and limit orders
   * count stable-to-stable pairs; Standard and Auto also count pairs in the same
   * liquid staking group; Solana counts all its like-kind pairs.
   */
  stables: number;
};

/**
 * Central fee definitions used by Matcha UI and request builders.
 *
 * All fees here are applied by this codebase. Standard and auto fees are sent
 * to 0x as Matcha's integrator fee while the `matcha-integrator-fees-enabled`
 * Vercel flag is on; with it off, 0x falls back to its own configuration
 * (Zippo for standard, rfq-api for auto) and these values only label it.
 */
export const matchaFees: Record<MatchaFeeType, MatchaFeeConfig> = {
  auto: { default: 25, stables: 0 },
  standard: { default: 25, stables: 0 },
  crossChain: { default: 40, stables: 4 },
  limitOrder: { default: 25, stables: 2 },
  solana: { default: 25, stables: 0 },
};

/** Matcha's integrator fee recipients, the same addresses 0x pays Matcha's `zeroExFee` to. */
export const matchaFeeRecipients: Record<MatchaSwapFeeFlow, string> = {
  standard: '0xad01c20d5886137e056775af56915de824c8fce5',
  auto: '0x38f5e5b4da37531a6e85161e337e0238bb27aa90',
};
